export default "__VITE_ASSET__CzHPHcxN__"